import type { PointsSummary, PointsTxn } from "./pointsTypes";

/**
 * 點數資料層（目前為 mock）。
 *
 * TODO(points-api): 後端尚無點數端點（lpg-aw-api 只有 cis_wallet＝電子錢包金額，不是點數）。
 * 端點到位後只需把 fetchPointsSummary / redeemPointsOnOrder 的實作換成 api.get/post，
 * 呼叫端（帳戶頁、點數明細頁、購物車）不必改。預期介面：
 *   GET  /app-api/customer/contexts/:context_id/points        → PointsSummary
 *   POST /app-api/platform-orders 的 body 帶 point_redeem: { stored_gas, account }
 */
export const POINTS_USE_MOCK = true;

/** 讓不同帳戶有不同（但固定）的假餘額，切帳戶時看得出來是各自獨立的點數。 */
const seedOf = (contextId: string): number => {
  let h = 0;
  for (let i = 0; i < contextId.length; i += 1) h = (h * 31 + contextId.charCodeAt(i)) % 9973;
  return h;
};

const daysAgo = (n: number): string => new Date(Date.now() - n * 86400000).toISOString();

const buildMock = (contextId: string): PointsSummary => {
  const seed = seedOf(contextId);
  const storedGas = 40 + (seed % 9) * 15; // 40 ~ 160 點
  const account = 120 + (seed % 7) * 90; // 120 ~ 660 點

  const txns: PointsTxn[] = [
    {
      id: `${contextId}-sg-2`,
      kind: "stored_gas",
      amount: storedGas - 25,
      balanceAfter: storedGas,
      title: "退桶剩餘氣折算",
      note: "20kg 桶 · 回收秤重",
      created_at: daysAgo(6),
    },
    {
      id: `${contextId}-ac-2`,
      kind: "account",
      amount: -60,
      balanceAfter: account,
      title: "訂單折抵",
      note: "訂單 #A2409-0182",
      created_at: daysAgo(11),
    },
    {
      id: `${contextId}-ac-1`,
      kind: "account",
      amount: account + 60,
      balanceAfter: account + 60,
      title: "溢繳金額轉入",
      note: "月結多繳",
      created_at: daysAgo(24),
    },
    {
      id: `${contextId}-sg-1`,
      kind: "stored_gas",
      amount: 25,
      balanceAfter: 25,
      title: "退桶剩餘氣折算",
      note: "16kg 桶 · 回收秤重",
      created_at: daysAgo(38),
    },
  ];

  return { context_id: contextId, balance: { storedGas, account }, txns };
};

/** 取得某瓦斯行帳戶的點數餘額與異動明細。contextId 為空時回 null（尚未選帳戶）。 */
export const fetchPointsSummary = async (contextId: string | null | undefined): Promise<PointsSummary | null> => {
  if (!contextId) return null;
  // mock 也走一次 microtask，呼叫端的 loading 分支才會跟接真 API 時走同一條路
  await Promise.resolve();
  return buildMock(String(contextId));
};
